const DEFAULT_SAFE_MESSAGE = "Something went wrong. Please try again later.";

/**
 * Scrub upstream/AI error strings that may contain internal URLs, httpx-style
 * "Server error '5xx'..." text, or bare gateway status codes before display.
 */
export function sanitizeUpstreamErrorMessage(
  msg: string,
  fallback: string = DEFAULT_SAFE_MESSAGE
): string {
  if (/Server error\s+'[0-9]/.test(msg) || /https?:\/\//.test(msg) || /\b50[234]\b/.test(msg)) {
    return fallback;
  }
  return msg;
}

/** True when a message looks like it may leak infrastructure details. */
export function looksLikeUpstreamLeak(msg: string): boolean {
  return /Server error\s+'[0-9]/.test(msg) || /https?:\/\//.test(msg) || /\b50[234]\b/.test(msg);
}
